module.exports = __webpack_public_path__ + "static/Goudy Old Style - Extra Bold-0f26ed723d21a56183960606b544b157.woff";